import React, {useState} from 'react';
import Page from "../../../components/Page";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import 'mapbox-gl/dist/mapbox-gl.css';
import "../../../services/mabox-gl";
import {VisitorsLocationMap} from "../../../components/Maps/VisitorsLocationMap";
import Card from "../../../components/Card";
import SiteSelect from "../../../components/InsightControls/SiteSelect";
import {Site} from "../../../types/Site";
import {useOperator} from "../../../context/OperatorContext";

// Helpers ----

const breadcrumbs = {
  "Insights": '/',
  "Visitors": '/insights/visitors',
  'Visitor Location': '/insights/visitors/location',
}

const defaultFilters: Filters = {
  siteId: null,
}

// Types ----

type Filters = {
  siteId?: number | null,
}

// Page ----

export function VisitorLocation() {
  const {termFor, isMultiSite} = useOperator();
  const [filters, setFilters] = useState<Filters>({...defaultFilters});

  function selectSite(site: Site | null) {
    setFilters(currentFilters => {
      return {...currentFilters, siteId: site?.id ?? null};
    })
  }

  return (
    <Page title='Visitor Location' breadcrumbs={breadcrumbs}>
      <div className='flex flex-col gap-4'>
        {isMultiSite &&
          <Card>
            <div className='flex flex-wrap gap-4'>
              <SiteSelect id="select-site" name="site" label={`${termFor('Site')}`} onChange={selectSite} showAnySiteOption={false} />
            </div>
          </Card>
        }

        <div className="relative shadow-md rounded-md overflow-hidden">
          <VisitorsLocationMap height="40rem" siteId={filters.siteId} />
        </div>
      </div>
    </Page>
  );
}